/**
 * Impide `/login` si ya hay sesión, salvo confirmación post-SSO (`?sso=complete`).
 */
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { DASHBOARD_ROUTE } from '../models/nav-item.model';

export const guestGuard: CanActivateFn = async (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.init();

  if (!authService.isAuthenticated()) {
    return true;
  }

  if (route.queryParamMap.get('sso') === 'complete') {
    return true;
  }

  const returnUrl = route.queryParamMap.get('returnUrl');
  const target = returnUrl && returnUrl.startsWith('/') ? returnUrl : DASHBOARD_ROUTE;
  return router.createUrlTree([target]);
};
